import { createContext, useContext } from 'react';
import type { AdminStaffRole } from '@lighthouse/shared';

export interface AdminUser {
  id: string;
  email: string;
  role: string;
  adminStaffRole?: AdminStaffRole;
}

export interface AdminAuthContextValue {
  user: AdminUser | null;
  loading: boolean;
  login: (userData: AdminUser, token: string) => void;
  logout: () => void;
}

export const AdminAuthContext = createContext<AdminAuthContextValue | null>(null);

export function useAdminAuth(): AdminAuthContextValue {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return context;
}
